import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./ui.css";

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: "small" | "medium" | "large" | "full";
  className?: string;
  closeOnBackdropClick?: boolean;
}

export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  size = "medium",
  className = "",
  closeOnBackdropClick = true,
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="ui-modal-backdrop"
      onClick={closeOnBackdropClick ? onClose : undefined}
      role="dialog"
      aria-modal
    >
      <div
        className={["ui-modal", `ui-modal--${size}`, className].filter(Boolean).join(" ")}
        onClick={(e) => e.stopPropagation()}
      >
        {(title != null) && (
          <div className="ui-modal__header">
            <h2 className="ui-modal__title">{title}</h2>
            <button className="ui-modal__close" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
        )}
        <div className="ui-modal__body">{children}</div>
        {(footer != null) && (
          <div className="ui-modal__footer">{footer}</div>
        )}
      </div>
    </div>,
    document.body
  );
}

export default Modal;
